module.exports = __webpack_public_path__ + "static/media/care_in_hospital.0965fc93.svg";